module.exports = __webpack_public_path__ + "img/etc-etc-new-arrow-r.480eb5e8.svg";